<template>
  <PageRoot>
    <PageBody class="py-24">
      <BlockContent class="text-center">
        <h1 class="page-title">
          404
        </h1>
        <h2 class="subpage-title">
          Sorry! Address not found.
        </h2>
        <div class="py-16 flex gap-4 justify-center">
          <TopLevelButtons>
            <template #after>
              <AButton
                to="/"
                label="Back Home"
                icon="i-carbon-home"
              />
            </template>
          </TopLevelButtons>
        </div>
      </BlockContent>
    </PageBody>
  </PageRoot>
</template>
